var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1951_3556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.008 1.5625L22.4001 13.1547L25.2864 6.31544L38.008 1.5625Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97632 1.5625L17.4587 13.2645L14.7136 6.31544L1.97632 1.5625Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.392 28.4326L28.2351 34.8012L37.1292 37.2483L39.6861 28.5738L32.392 28.4326Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.329102 28.5738L2.87028 37.2483L11.7644 34.8012L7.60753 28.4326L0.329102 28.5738Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2626 17.6723L8.78418 21.4213L17.6156 21.8134L17.3018 12.3232L11.2626 17.6723Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7215 17.6727L22.6038 12.2139L22.3999 21.8139L31.2156 21.4217L28.7215 17.6727Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7644 34.8014L17.0664 32.2132L12.486 28.6367L11.7644 34.8014Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9175 32.2132L28.2351 34.8014L27.4979 28.6367L22.9175 32.2132Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2354 34.8021L22.9177 32.2139L23.3413 35.6805L23.2942 37.1394L28.2354 34.8021Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7646 34.8021L16.7058 37.1394L16.6745 35.6805L17.0666 32.2139L11.7646 34.8021Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7844 26.3466L12.3608 25.0446L15.4824 23.6172L16.7844 26.3466Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2002 26.3466L24.5022 23.6172L27.6394 25.0446L23.2002 26.3466Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7648 34.8012L12.5177 28.4326L7.60791 28.5738L11.7648 34.8012Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4824 28.4326L28.2354 34.8012L32.3922 28.5738L27.4824 28.4326Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2158 21.4209L22.4001 21.8131L23.2158 26.3464L24.5178 23.617L27.655 25.0444L31.2158 21.4209Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3609 25.0444L15.4981 23.617L16.7844 26.3464L17.6158 21.8131L8.78442 21.4209L12.3609 25.0444Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78442 21.4209L12.4864 28.6366L12.3609 25.0444L8.78442 21.4209Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6552 25.0444L27.4983 28.6366L31.2159 21.4209L27.6552 25.0444Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.616 21.8135L16.7847 26.3468L17.82 31.6958L18.0553 24.6527L17.616 21.8135Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4003 21.8135L21.9768 24.637L22.165 31.6958L23.216 26.3468L22.4003 21.8135Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2158 26.3469L22.1648 31.6959L22.9177 32.2135L27.4981 28.6371L27.655 25.0449L23.2158 26.3469Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3608 25.0449L12.4863 28.6371L17.0667 32.2135L17.8197 31.6959L16.7844 26.3469L12.3608 25.0449Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2941 37.139L23.3411 35.6802L22.949 35.3351H17.0352L16.6745 35.6802L16.7058 37.139L11.7646 34.8018L13.4901 36.2135L16.9882 38.6449H22.996L26.5097 36.2135L28.2352 34.8018L23.2941 37.139Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9177 32.2139L22.1648 31.6963H17.8197L17.0667 32.2139L16.6746 35.6806L17.0353 35.3355H22.9491L23.3412 35.6806L22.9177 32.2139Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 13.9076L40.0001 7.5076L38.0079 1.5625L22.9177 12.7625L28.7216 17.6723L36.9256 20.0723L38.7452 17.9547L37.9609 17.39L39.2158 16.2449L38.2432 15.4919L39.4981 14.5351L38.6667 13.9076Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.5076L1.33333 13.9076L0.486275 14.5351L1.74118 15.4919L0.784314 16.2449L2.03922 17.39L1.2549 17.9547L3.05882 20.0723L11.2627 17.6723L17.0667 12.7625L1.97647 1.5625L0 7.5076Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9255 20.0719L28.7216 17.6719L31.2157 21.4209L27.498 28.6366L32.3922 28.5738H39.6863L36.9255 20.0719Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2627 17.6719L3.05876 20.0719L0.329346 28.5738H7.60778L12.4862 28.6366L8.78425 21.4209L11.2627 17.6719Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4001 21.8135L22.9178 12.7625L25.3021 6.31543H14.7139L17.0668 12.7625L17.6158 21.8135L17.8041 24.6684L17.8197 31.6958H22.1648L22.1962 24.6684L22.4001 21.8135Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1951_3556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.9838d3eb481e95f06e635a25171fb28c.svg";
export { ForwardRef as ReactComponent };